export {default} from './EmptyReportContent';
